import { useState } from "react";
import { post } from "../networking/RequestService";

const useGetProcessMimeMessage = (mailId) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [mailContent, setMailContent] = useState(null);

    const processMimeMessage = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "processMimeMessage",
                mailId: mailId,
            });

            if (res && res.data && res.data.html) {
                setMailContent(res.data.html);
                return res.data.html;
            }
            return null;
        } catch (err) {
            setError(err);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, mailContent, refetch: processMimeMessage };
};

export default useGetProcessMimeMessage;
